module.exports = {"330411002":"新城街道","330411003":"嘉北街道","330411004":"塘汇街道","330411005":"高照街道","330411101":"王江泾镇","330411103":"油车港镇","330411104":"新塍镇","330411105":"王店镇","330411106":"洪合镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330411.json
// module id = 1083
// module chunks = 0